import { render, staticRenderFns } from "./apply.vue?vue&type=template&id=10ed8610&scoped=true"
import script from "./apply.vue?vue&type=script&lang=js"
export * from "./apply.vue?vue&type=script&lang=js"
import style0 from "./apply.vue?vue&type=style&index=0&id=10ed8610&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ed8610",
  null
  
)

export default component.exports